<script>
    import { onMount } from 'svelte';
    
    import Section from './Section.svelte'
    import Footer from './Footer.svelte'

    import Home from './Home.svelte'
    import About from './About.svelte'
    import Services from './Services.svelte'
    import Skills from './Skills.svelte'
    import Contact from './Contact.svelte'

    let showSkills = false;

    onMount(async () => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animation-fade')
                }
            })
        })
      
        const observerSkills = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animation-fade')
                    showSkills = true
                }
            })
        })
      
        observer.observe(document.querySelector('#about'))
        observerSkills.observe(document.querySelector('#skills'))
        observer.observe(document.querySelector('#service'))
        observer.observe(document.querySelector('#contact'))
    })
</script>

<main>
    <div class="mx-auto">
        <Home id="home"/>
        <Section id="about">
            <About />
        </Section>
        <Section id="service">
            <Services />
        </Section>
        <Section id="skills">
            {#if showSkills}
                <Skills />
            {/if}
        </Section>
        <Section id="contact">
            <Contact />
        </Section>
    </div>
</main>
<Footer />
